import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicCsatFeedbackComponent } from './public-csat-feedback.component';
import { PublicCsatFeedbackFormComponent } from './public-csat-feedback-form/public-csat-feedback-form.component';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    NgbRatingModule
  ],
  declarations: [PublicCsatFeedbackComponent, PublicCsatFeedbackFormComponent],
  exports: [PublicCsatFeedbackComponent],
  providers: []
})
export class PublicCsatFeedbackModule { }